import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchContentLibraryThunk } from 'slices/campaigns/content/thunk';
import { AppDispatch, RootState } from 'store';
import { encodeBase64, formatNumber, generateUniqueKey } from 'utils/helpers';
import IGLogoPNG from "../../assets/images/brands/ig-logo.png"
import Skeleton from 'react-loading-skeleton';
import { defaultFiltersValue } from 'Components/campaigns/collaborations/milestone/Filters';
import { fetchAllCollaborationsThunk } from 'slices/campaigns/collaborations/thunk';
import { Collaboration, MilestoneStepAssigneeLabel } from 'types/campaign/collaborations';
import { Link } from 'react-router-dom';
const filters = defaultFiltersValue;

const OngoingCollabsPreview = () => {

    const [initialLoading, setInitialLoading] = useState(false);
    const [filterId, setFilterId] = useState(generateUniqueKey(filters, ['page']))
    const dispatch: AppDispatch = useDispatch();
    const collaborationsData = useSelector((state: RootState) => state.collaborations.collaborations.filtered_lists[filterId!]);
    const collaborations = collaborationsData?.list ?? [];

    useEffect(() => {
        if (filters.page && filters.page === 1) {
            setInitialLoading(true);
        }

        dispatch(fetchAllCollaborationsThunk({ filters })).finally(() => {
            setFilterId(generateUniqueKey(filters, ['page']));
            setInitialLoading(false);
        })

    }, [filters])

    return (
        <div className='table-responsive dashboard-table'>
            <table className="">
                <thead>
                    <tr>
                        <th style={{width: '30%'}}>Creator</th>
                        <th className='text-start ps-4' style={{width: '55%'}}>Campaign</th>
                        <th className='text-start ps-4' style={{width: '15%'}}>Pending On</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        !initialLoading && collaborations.slice(0, 5).map((collaboration, i) => {
                            return (
                                <tr className={`${i < 4 ? 'border-bottom-1 px-3' : ''} `} key={i}>
                                    <td style={{width: '30%'}}>
                                        <div className="py-3">
                                            <div className="d-flex justify-content-start align-items-center gap-3 td-content">
                                                <div className='bgc-content bg-image cursor-pointer' style={{ backgroundImage: `url(${collaboration.influencer.social_account.profile_picture_url})`, height: '40px', width: '40px', borderRadius: '50%' }}></div>
                                                <div className="d-flex flex-column justify-content-center">
                                                    <div className="d-flex align-items-center gap-1">
                                                        {
                                                            collaboration.influencer.social_account.platform === 'ig' &&
                                                            <img src={IGLogoPNG} alt="IG Logo" className='linked-posts-ig-logo' />
                                                        }
                                                        {
                                                            collaboration.influencer.social_account.platform === 'yt' &&
                                                            <i className='ri-youtube-fill text-danger linked-posts-yt-logo mt-1'></i>
                                                        }

                                                        <span className='linked-posts-ig-username text-start'>{collaboration.influencer.name}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className='ps-4' style={{width: '55%'}}>
                                        <div className="py-3">
                                            <div className="d-flex justify-content-start align-items-center gap-1 td-content">
                                                <span className='text-start'>{collaboration.campaign.name}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td className='ps-4' style={{width: '15%'}}>
                                        <div className="py-3">
                                            <div className="d-flex justify-content-start align-items-center gap-1 td-content">
                                                <span className='text-start'>
                                                  {MilestoneStepAssigneeLabel[collaboration.active_steps?.[0].assignees?.[0]! as keyof typeof MilestoneStepAssigneeLabel]}
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                   
                                </tr>
                            )
                        })
                    }
                    {
                        (initialLoading) &&
                        Array.from({ length: 10 }).map((_, i) => {
                            return (
                                <tr>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                </tr>
                            )
                        })
                    }
                    {
                        ((!initialLoading && collaborations.length === 0)) &&
                        <tr>
                            <td colSpan={3} className="text-center py-4">
                               <span className='my-5'>Currently there is no collab in your list!</span>
                            </td>
                        </tr>   
                    }
                </tbody>
            </table>
        </div>
    )
}

export default OngoingCollabsPreview